import LandingPageHeader from './LandingPageHeader'

export default LandingPageHeader
